import { Pipe, PipeTransform } from '@angular/core';
import { formatCalendarDate } from './date-utility';

/** Date-only fields (CP Date, Return Date). Prints the stored Y-M-D in every timezone. */
@Pipe({
	name: 'dateOnly'
})
export class DateOnlyPipe implements PipeTransform {
	transform(value: Date | string | null | undefined): string {
		return formatCalendarDate(value) ?? '';
	}
}
